import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from '@mui/material';

export default function ServiceTable({ rows }) {
  return (
    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #eee', borderRadius: 1 }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: '#fff0f7' }}>
            <TableCell sx={{ fontFamily: '"Lato", sans-serif', fontWeight: 700, color: '#333', fontSize: '0.85rem', py: 1.2 }}>
              Service
            </TableCell>
            <TableCell align="right" sx={{ fontFamily: '"Lato", sans-serif', fontWeight: 700, color: '#333', fontSize: '0.85rem', py: 1.2 }}>
              Price
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow
              key={i}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                '&:hover': { backgroundColor: '#fffafd' },
                transition: 'background 0.15s',
              }}
            >
              <TableCell sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.83rem', color: '#444', py: 1.1 }}>
                {row.service}
              </TableCell>
              <TableCell align="right" sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.83rem', color: '#FF0099', fontWeight: 600, py: 1.1 }}>
                {row.price}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}